import CityPageTemplate from "../city-template/CityPageTemplate";
import { rockSpringsConfig } from "./data";

export default function RockSpringsPage() {
  return <CityPageTemplate config={rockSpringsConfig} />;
}